import { render } from "./UserPrivacyModal.vue?vue&type=template&id=2751bf36&scoped=true"
import script from "./UserPrivacyModal.vue?vue&type=script&lang=js"
export * from "./UserPrivacyModal.vue?vue&type=script&lang=js"

import "./UserPrivacyModal.vue?vue&type=style&index=0&id=2751bf36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2751bf36"

export default script